<template>
    <v-dialog v-model="dialog" max-width="450">
        <template v-slot:activator="{ on }">
            <div class="d-flex" v-on="on" style="cursor:pointer">
                <v-icon :color="$vuetify.theme.themes.dark.primary">calendar_today</v-icon>
                <span class="ml-1">
                    {{ $t('с') }}&nbsp;{{ getDateFromValue() | formatDate }}
                    <br />
                    {{ $t('по') }}&nbsp;{{ getDateToValue() | formatDate }}
                </span>
            </div>
        </template>
        <LabeledCard :label="label">
            <v-form @submit="handleSubmit()" onsubmit="return false;" :ref="formRef" class="pa-4">
                <span class="font-weight-bold label">{{ $t('selectPeriod') }}</span>
                <v-row>
                    <v-col>
                        <DatePicker outlined :label="$t('Дата с')" class="date-filter" v-model="from" />
                    </v-col>
                    <v-col>
                        <DatePicker outlined :label="$t('Дата по')" class="date-filter" :rules="[checkStatusDate(from, to)]" v-model="to" />
                    </v-col>
                </v-row>
                <div class="d-flex">
                    <v-btn @click="handleCancel" outlined :color="$vuetify.theme.themes.dark.primary" class="rounded-btn ml-auto mr-2">{{
                        $t('Отмена')
                    }}</v-btn>
                    <v-btn type="submit" dark class="rounded-btn" :color="$vuetify.theme.themes.dark.primary">{{ $t('Применить') }}</v-btn>
                </div>
            </v-form>
        </LabeledCard>
    </v-dialog>
</template>

<script>
import { isObjectEmpty, cloneObject } from '@/utils';
import LabeledCard from '@/components/ui/LabeledCard';
import DatePicker from '@/components/ui/DatePicker';
import FormValidator from '@/mixins/FormValidator';

export default {
    props: ['value', 'field', 'label'],
    mixins: [FormValidator],
    components: {
        LabeledCard,
        DatePicker
    },
    data() {
        return {
            dialog: false,
            from: '',
            to: ''
        };
    },
    methods: {
        handleSubmit() {
            if (!this.validateForm()) return;
            this.$emit('input', cloneObject({ ...this.value, [this.getDateFromModel()]: this.from, [this.getDateToModel()]: this.to }));
            this.dialog = false;
        },
        handleCancel() {
            this.dialog = false;
            this.init();
        },
        getDateFromModel() {
            return `${this.field}_date_from`;
        },
        getDateToModel() {
            return `${this.field}_date_until`;
        },
        getDateFromValue() {
            return this.value[this.getDateFromModel()];
        },
        getDateToValue() {
            return this.value[this.getDateToModel()];
        },
        init() {
            this.from = this.value[this.getDateFromModel()];
            this.to = this.value[this.getDateToModel()];
        }
    },
    created() {
        this.init();
    }
};
</script>
<style></style>
